<template>
	<div class="contentTab">
<!--		:defaultSort="managerStatementsSort"-->
		<main-table-all-back
				v-if="managerStatementsFilters"
				textCreate="generate"
				:flag="flag"
				page-title="Manager statements"
				:headers="headers"
				:settings="getSettings"
				:filtersList="managerStatementsFilters"
				:list="managerStatementsList"
				:defaultOrder="managerStatementsOrder"

				:defaultFilter="defaultFilter"
				:totals="managerStatementsTotals"
				:total-pages="managerStatementsTotal"
				:limit-pages="managerStatementsLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters($event || activeTableFilters || defaultFilter)"

				@updateExport="onExport"
				:is-export="isExport()"
				:is-export-permissions="true"
				:is-create="false"
				:department_id="user.department_id"

				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"

		></main-table-all-back>

		<manager-statements-form
				v-if="isManagerStatementsForm"
				:isEdit="isEdit"
				:managerStatementsItem="managerStatementsItem"
				:managerStatementsMonth="managerStatementsMonth"
				:managerStatementsDepartments="managerStatementsDepartments"
				@updateCloseDialog="onCloseDialog"
		></manager-statements-form>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

	</div>
</template>

<script>
/* eslint-disable */
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import ManagerStatementsForm
	from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/ManagerStatementsForm.vue";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import { PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import DialogRemove from "@/shared/DialogRemove/DialogRemove";
import { TITLE } from "@/pages/Settings/UserAccountSettings/constants";


export default {
	name: "StatementsManager",
	components: { DialogRemove, MainTableAllBack, ManagerStatementsForm },
	mixins: [ settingsMixins ],
	props: {
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
		textGeneralTitle: {
			type: String,
			default: "Statements Items",
		},
		user: Object,
	},
	computed: mapGetters([
		"managerStatementsList",
		"managerStatementsFilters",
		"managerStatementsTotals",
		"managerStatementsOrder",
		"managerStatementsLimit",
		"managerStatementsSort",
		"managerStatementsTotal",
		"managerStatementsMonth",
		"managerStatementsDepartments",
		"managerStatementsItem",
		"permissions",
		"permissionsDefault",
	]),
	data: () => ({
		flag: PAGE.MANAGER_STATEMENTS,
		isManagerStatementsForm: false,
		defaultFilter: null,
		managerId: null,
		isEdit: false,
		id: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,

		dispatcher_id: null,
		activeTableFilters: null,


		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)
	}),
	methods: {
		...mapActions([
			'getManagerStatements',
			'getManagerStatementsFilters',
			'actionPreloader',
			'onExportLink',
			'onManagerStatementsRemoveItem',
			'getManagerStatementsCreate',
			'onManagerStatementsView',
			'onClearManagerStatements',
			'getManagerStatementsUser',
		]),

		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},
		async onCloseDialog(value) {
			if (value) await this.onUpdateFilters();
			this.isManagerStatementsForm = false;
			this.onClearManagerStatements();
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isManagerStatementsForm = true;
				this.isEdit = false;
			}
		},
		// async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
		// 	if (!isWithoutPayload) this.actionPreloader(true);
		// 	// await this.getManagerStatements(filters);
		// 	// if (!isWithoutFilters) await this.getManagerStatementsFilters(filters);
		//
		// 	const id = this.id;
		//
		// 	if (!filters) {
		// 		filters = {}; // создаем объект, если его нет
		// 	}
		// 	filters.id = id;
		//
		// 	// // Проверяем, есть ли в filters массив filter_dispatcher_name
		// 	// if (Array.isArray(filters.filter_dispatcher)) {
		// 	// 	// Если массив существует, добавляем id в него
		// 	// 	filters.id = id;
		// 	// } else {
		// 	// 	// Если массива нет, создаем его с id
		// 	// 	filters.id = id ;
		// 	// }
		//
		// 	// Выполняем обновление фильтра
		// 	await this.getManagerStatementsFilters(filters);
		// 	await this.getManagerStatements(filters);
		//
		// 	if (!isWithoutPayload) this.actionPreloader(false);
		// },

		async onUpdateFilters(filters = {}, isWithoutFilters) {

			if (!filters || typeof filters !== 'object') {
				filters = {};
			}

			await this.getManagerStatements(filters);
			if (!isWithoutFilters) await this.getManagerStatementsFilters(filters);
			// await this.getTotalLogbooksMod(filters);
		},

		// async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
		// 	if (!isWithoutPayload) this.actionPreloader(true);
		// 	await this.getManagerStatements(filters);
		// 	if (!isWithoutFilters) await this.getManagerStatementsFilters(filters);
		// 	if (!isWithoutPayload) this.actionPreloader(false);
		// },
		async onList(values) {
			const { value, flag } = values;
			console.log('%c [  flag  ] ', 'color:#bada55', typeof flag, flag );
			console.log('%c [  value  ] ', 'color:#bada55', typeof value, value );
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getManagerStatements(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		async onExport(values) {
			values.id = this.id;
			values.setting = [
				"month",
				"created_date",
				"created_by",
				"department",
				"dispatcher",
				"salary",
				"bonus",
				"description",
				"total",
			];
			await this.onExportLink({ values, requestKey: 'salary-statements', isSetting: 1  });
		},
		async onClickButton({ key, item }) {
			this.activeItem = item;
			if (key === 'view') {
				this.actionPreloader(true);
				await this.onManagerStatementsView(item.id);
				this.isEdit = true;
				this.isManagerStatementsForm = true;
				this.actionPreloader(false);
			}

			if (key === "delete") {
				const { total, month } = item;
				const title = TITLE.REMOVE_STATEMENTS;
				const text = `📋 The manager statement of <b>${ total }</b> 💰 for <b>${ month }</b> 📅.`;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			this.isPreloader = true;
			
			await this.onManagerStatementsRemoveItem(this.activeItem);
			this.onCloseRemove();
			await this.onUpdateFilters(this.defaultFilter);
			this.isPreloader = false;
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},
	},




	async mounted() {
		const id = this.$route.params.id;

		this.id = id;

		const {dispatcher_id} = this.user;
		this.dispatcher_id = dispatcher_id


		// await this.onBonusChargeFilterUser({ filter_employee: [ id ] });

		// await this.onUpdateFilters();

		const filters = {
			filter_dispatcher: [dispatcher_id],
			limit: 15,
			order: "invoice_id",
			page: 1,
			sort: "desc"
		}
		this.defaultFilter = filters

		// await this.getManagerStatementsUser(filters);
		// await this.getManagerStatementsFilters(filters);
		await this.onUpdateFilters(this.defaultFilter);
	}
};
</script>

<style scoped lang="scss">

</style>
